import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';
import TopicSubscribeButton from '../../../Community/TopicSubscribeButton/TopicSubscribeButton';
import { SingleContentTopicProps } from '../../../Includes/TopicPropsShape';
import HoverCallToAction from '../HoverCallToAction';
import './TopicLayout.scss';

export default class TopicLayout extends React.PureComponent {
    renderMainContent = () => {
        return (
            <div className="topic-layout-main-content">
                <div className="title-text">{this.props.topic.title}</div>
                <div className="total-resources-text">{`${this.props.topic.total} Convos & Resources`}</div>
                <div className="topic-link">
                    <a href={`/community/${this.props.topic.url}`}>
                        View Topic {'>'}
                    </a>
                </div>
            </div>
        );
    };

    renderCallToAction = () => {
        return (
            <PageConsumer>
                {(context) => (
                    <TopicSubscribeButton
                        user={context.pageProps.session}
                        topic={this.props.topic}
                    />
                )}
            </PageConsumer>
        );
    };

    render() {
        return (
            <div className="component-CallToAction-HoverCallToAction-TopicLayout">
                <HoverCallToAction mainContent={this.renderMainContent()} />
            </div>
        );
    }
}

TopicLayout.propTypes = {
    topic: PropTypes.shape(SingleContentTopicProps),
};

TopicLayout.defaultProps = {
    topic: {},
};
